import { Box, Slider, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Dispatch, SetStateAction, useMemo, useState } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { DailyConsumptionSliderMarks } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/constants/daily-consumption-slider-marks';
import { useInputSettingsState } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/context/input-settings-context';
import { OutlinedBox } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/utils/styled-components';

type Props = {
  setDailyConsumptionPrognosis: Dispatch<SetStateAction<number>>;
};

const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan.inputSettings.dailyConsumptionRateTab';

const DailyConsumptionPrognosis: React.FC<Props> = ({ setDailyConsumptionPrognosis }) => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const {
    getOfdSettingsQuery: { data: ofdSettings },
  } = useInputSettingsState();

  const [sliderValue, setSliderValue] = useState<number>(ofdSettings?.manualConsumptionRateCoefficient ?? 1.0);

  const calculatedConsumptionRate = useMemo(() => {
    return sliderValue * (ofdSettings?.originalConsumptionRate || 0);
  }, [sliderValue, ofdSettings?.originalConsumptionRate]);

  return (
    <>
      <OutlinedBox>
        {ofdSettings?.manualConsumptionRateCoefficient}
        <Box display={'flex'} justifyContent={'space-between'} flexDirection={!isMobile ? 'row' : 'column'}>
          <Typography>
            <FormattedMessage id={`${PAGE_NAME_ID}.sliderTitle`} />
          </Typography>
          <Box display={'flex'} gap={2} mb={10} justifyContent={isMobile ? 'space-between' : 'normal'} mt={isMobile ? 4 : 0}>
            <Box p={3} borderRadius={2} display={'flex'} alignItems={'center'} sx={{ background: theme.palette.lightBlue.o25 }}>
              <Typography fontWeight={600} mr={2}>
                {Math.round(sliderValue * 100)}%
              </Typography>
              <Typography>
                (
                <FormattedNumber value={Number(calculatedConsumptionRate)} maximumFractionDigits={0} unit={'kilogram'} style="unit" />)
              </Typography>
            </Box>
          </Box>
        </Box>
        <Slider
          aria-label="Always visible"
          step={null}
          value={sliderValue}
          valueLabelDisplay="on"
          onChange={(e, v) => {
            setSliderValue(v as number);
            setDailyConsumptionPrognosis(v as number);
          }}
          marks={DailyConsumptionSliderMarks}
          valueLabelFormat={(v, i) => `${Math.round(v * 100)}%`}
          min={0}
          max={3}
        />
      </OutlinedBox>
    </>
  );
};

export default DailyConsumptionPrognosis;
